module.exports = __webpack_public_path__ + "static/img/gov_portal.58f55c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gov_portal.png
// module id = Ldof
// module chunks = 1